<template>
    <button
        type="button"
        class="announcements-button"
        title="Avisos"
        aria-label="Avisos"
        @click="$emit('click')"
    >
        <a-badge :count="count" :offset="[2, -2]">
            <span class="material-icons-outlined announcements-icon">campaign</span>
        </a-badge>
    </button>
</template>

<script>
export default {
    name: "AnnouncementsButton",
    props: {
        count: { type: Number, default: 0 },
    },
};
</script>

<style>
.header-actions .announcements-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    padding: 6px;
    background: transparent !important;
    color: #525252 !important;
    line-height: 1;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
}
.header-actions .announcements-button:hover {
    background: #eeeeee !important;
    border-color: #ff432d;
    color: #ff432d !important;
}
/* A regra global ".header-actions *" força cor/fundo; o ícone acompanha o botão. */
.header-actions .announcements-button .announcements-icon {
    color: inherit !important;
    background: transparent !important;
    font-size: 18px;
}
</style>
